export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-minibar/index.js